/*
remove this comment block if this module needs getters

import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildElementGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);
*/

// getters declarations

const getters = {};

export default getters;
